import { OPTIONS_AGREGATEUR_MANDAT } from '@/shared/utils/agregateurMandat';

// Le choix de l'agregateur d'un mandat, AVANT la signature (C8a). Partage par le CRM et le
// parcours terrain, pour que les deux ecrans posent la meme question avec les memes mots.
// Le pourquoi et la liste : `shared/utils/agregateurMandat.js`.
export default function ChoixAgregateurMandat({ valeur, onChange, testid = 'choix-agregateur-mandat' }) {
  return (
    <div className="space-y-1.5">
      <label htmlFor={testid} className="text-sm font-medium text-slate-800">
        Agrégateur du mandat
      </label>
      <select id={testid} data-testid={testid} value={valeur || ''}
              onChange={(e) => onChange(e.target.value)}
              className="w-full h-9 rounded-md border border-neutral-200 px-2 text-sm bg-white">
        {OPTIONS_AGREGATEUR_MANDAT.map((option) => (
          <option key={option.valeur || 'generique'} value={option.valeur}>{option.libelle}</option>
        ))}
      </select>
      <p className="text-[12px] text-slate-500">
        À choisir avant la signature : les équipements de ce mandat ne pourront être
        déclarés qu&apos;à cet agrégateur, et la déclaration est définitive.
      </p>
    </div>
  );
}
